import getUrl from '../../../getUrl';

function Example() {

    return <>
        <div>
            <iframe 
                title="zkon-widget" 
                style={{width: '100%', height: '100vh'}}
                src={
                    getUrl() +
                    "/account/demo"
                }
            ></iframe>
        </div>
    </>
}

export default Example;